export default [{
  name: 'bmpag',
  namespaced: true,
  state: {
    balance: 0,
    transacaoresult : ""
  },
  mutations: {
    transacaoresult(state, obj)
    {
      state.transacaoresult = obj
    },
    balance(state, obj) {
      state.balance = obj
    }
  },
  getters: {
    transacaoresult(state) {
      return state.transacaoresult 
    },
    balance(state) {
      return state.balance 
    }
  }
}]
